import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../../CheckBox';
import { memoItem } from '../helpers';
import { CheckboxOption as OptionElement } from '../elements';

var CheckboxOption = function CheckboxOption(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      isSelected = _ref.isSelected;
  var handleClick = useCallback(function () {
    return !disabled && onChange(value);
  }, [disabled, onChange, value]);
  return /*#__PURE__*/React.createElement(OptionElement, {
    role: "menuitem",
    disabled: disabled,
    className: className,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(CheckBox.Bullet, {
    isChecked: isSelected
  }), label);
};

var bool = PropTypes.bool,
    func = PropTypes.func,
    node = PropTypes.node,
    string = PropTypes.string;
/**
 *
 * PropTypes validation
 */

CheckboxOption.propTypes = {
  value: node.isRequired,
  className: string,
  disabled: bool,
  label: node.isRequired,
  onChange: func.isRequired,
  isSelected: bool
};
/**
 * Default props
 */

CheckboxOption.defaultProps = {
  className: '',
  disabled: false,
  isSelected: null
};
export default memoItem(CheckboxOption);